import { render, staticRenderFns } from "./NurseDetails.vue?vue&type=template&id=49c32afe&scoped=true&"
import script from "./NurseDetails.vue?vue&type=script&lang=js&"
export * from "./NurseDetails.vue?vue&type=script&lang=js&"
import style0 from "./NurseDetails.vue?vue&type=style&index=0&id=49c32afe&scoped=true&lang=css&"
import style1 from "./NurseDetails.vue?vue&type=style&index=1&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "49c32afe",
  null
  
)

export default component.exports